<div class="relative w-full h-full bg-slate-50 flex flex-col overflow-hidden font-sans">

  <!-- Header Bar -->
  <div
    class="relative bg-gradient-to-b from-[#2e2f38] to-[#1a1b20] pt-5 pb-6 rounded-b-[2.5rem] shadow-lg z-10 shrink-0 text-white border-b border-white/5">

    <div class="absolute left-4 top-4 z-20">
      <button
        class="w-9 h-9 p-2 bg-white/10 hover:bg-white/20 backdrop-blur-md shadow-sm rounded-full flex justify-center items-center active:scale-95 transition-all border border-white/10 text-white outline-none"
        (click)="goback()">
        <img src="icons/arrow_back_white.svg" class="w-full h-full" />
      </button>
    </div>

    <div class="flex flex-col items-center justify-center mt-1 text-center">
      <h2 class="text-base font-black tracking-wide text-white">
        {{ currentLang === "TH" ? "รายการรถที่กำลังจอดอยู่" : "Currently Parked Cars" }}
      </h2>
      <p class="text-[9px] text-amber-400 font-bold mt-1 uppercase tracking-wider">
        {{ currentLang === "TH" ? "ตรวจสอบประวัติและยอดชำระค่าบริการ" : "Check parking status & payments" }}
      </p>
    </div>
  </div>

  <!-- Main Scroll Container -->
  <div class="flex-1 overflow-y-auto custom-scrollbar px-4 pb-20 pt-4 space-y-4">

    <!-- Search Box -->
    <div
      class="relative w-full h-11 rounded-2xl bg-white shadow-sm flex items-center px-4 border border-slate-100 focus-within:border-amber-400 focus-within:ring-1 focus-within:ring-amber-400 transition-all">
      <img src="icons/search_slate.svg" class="w-5 h-5 mr-2" />
      <input type="text" [(ngModel)]="searchText" (input)="onSearch()"
        class="w-full h-full bg-transparent outline-none text-slate-800 placeholder-slate-400 text-xs font-medium"
        placeholder="{{ currentLang === 'TH' ? 'ค้นหาหมายเลขทะเบียนรถ...' : 'Search plate number...' }}">

      <button *ngIf="searchText" (click)="onClearSearch(); onSearch()"
        class="text-slate-400 hover:text-rose-500 transition outline-none">
        <img src="icons/cancel_slate.svg" class="w-full h-full" />
      </button>
    </div>

    <!-- KPI Statistics Grid (Additional Premium Feature) -->
    <div class="grid grid-cols-2 gap-3" *ngIf="dataVehicle.length > 0">
      <!-- Total Parked Card -->
      <div class="bg-white rounded-3xl p-3.5 border border-slate-100 shadow-sm text-left flex items-center gap-3">
        <div
          class="w-10 h-10 rounded-2xl bg-emerald-50 text-emerald-600 flex items-center justify-center flex-shrink-0">
          <img src="icons/local_parking_emerald.svg" class="w-6 h-6" />
        </div>
        <div class="min-w-0">
          <span class="text-[8px] font-bold text-slate-400 uppercase tracking-wider block">{{ currentLang === "TH" ?
            "จอดอยู่ปัจจุบัน" : "Parked" }}</span>
          <span class="text-sm font-black text-slate-800">{{ totalVehiclesCount }} {{ currentLang === "TH" ? "คัน" :
            "cars" }}</span>
        </div>
      </div>

      <!-- Pending Payments Card -->
      <div class="bg-white rounded-3xl p-3.5 border border-slate-100 shadow-sm text-left flex items-center gap-3">
        <div class="w-10 h-10 rounded-2xl bg-amber-50 text-amber-500 flex items-center justify-center flex-shrink-0">
          <img src="icons/payments_orange.svg" class="w-6 h-6" />
        </div>
        <div class="min-w-0">
          <span class="text-[8px] font-bold text-slate-400 uppercase tracking-wider block">{{ currentLang === "TH" ?
            "ยอดค้างชำระรวม" : "Total Pending" }}</span>
          <span class="text-sm font-black text-slate-800 truncate block">{{ totalPendingPayment | number : "1.2-2" }}
            ฿</span>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="(filteredDataVehicle ? filteredDataVehicle : dataVehicle).length === 0"
      class="flex flex-col items-center justify-center py-20 text-slate-400">
      <i class="fa fa-car text-5xl opacity-40 mb-3"></i>
      <p class="text-xs font-bold">{{ currentLang === "TH" ? "ไม่พบรถยนต์ที่กำลังจอดอยู่" : "No parked vehicle found" }}
      </p>
      <p class="text-[10px] text-slate-400 mt-1 max-w-[200px] text-center leading-normal">
        {{ currentLang === "TH" ? "ขณะนี้ไม่มีประวัติรถยนต์ของคุณกำลังจอดในระบบ" : "There are currently no active
        parking sessions linked to your account." }}
      </p>
    </div>

    <!-- Active Parked Vehicles List -->
    <div class="space-y-3.5">
      <div *ngFor="let parkingList of (filteredDataVehicle ? filteredDataVehicle : dataVehicle)"
        class="bg-white rounded-[2rem] p-4.5 border border-slate-100 shadow-sm relative overflow-hidden transition-all duration-200 hover:shadow-md flex flex-col gap-3.5">

        <!-- Left vertical status bar indicator -->
        <div class="absolute left-0 top-0 bottom-0 w-1.5"
          [ngClass]="parkingList.totalPay > 0 ? 'bg-rose-500' : 'bg-emerald-500'"></div>

        <!-- Upper Row: Logo, Plate details & Date -->
        <div class="flex gap-3.5 items-start">
          <div
            class="w-14 h-14 bg-slate-50 rounded-2xl p-1 flex-shrink-0 border border-slate-100 flex items-center justify-center overflow-hidden">
            <img [src]="parkingList.logo || 'assets/default-car.png'"
              class="w-full h-full object-contain mix-blend-multiply" alt="car-logo" />
          </div>

          <div class="flex-1 min-w-0 text-left">
            <div class="flex justify-between items-start">
              <!-- Plate badge -->
              <div
                class="flex items-center border border-slate-300 bg-white rounded px-2.5 py-0.5 min-w-[85px] justify-center relative overflow-hidden shadow-sm">
                <span class="text-xs font-black text-slate-800 tracking-wide font-prompt text-center leading-none">
                  {{ parkingList.entryLicense }}
                  <span class="text-[7px] text-slate-400 font-bold block leading-none text-center mt-1">
                    {{ parkingList.provinceName }}
                  </span>
                </span>
              </div>
              <!-- Entry Date -->
              <span class="text-[8px] font-bold text-slate-400 font-mono tracking-wide uppercase">
                IN: {{ parkingList.entryDate | date : "dd/MM/yy HH:mm" }}
              </span>
            </div>

            <!-- Site Location -->
            <p class="text-[10px] text-slate-400 font-bold mt-2 truncate flex items-center gap-1">
              <img src="icons/location_on_slate.svg" class="w-4 h-4" />
              {{ parkingList.siteName }}
            </p>
          </div>
        </div>

        <!-- Bottom Row: Time details, Pending fee and payment button -->
        <div class="flex items-center justify-between border-t border-slate-100 pt-3 text-xs">
          <!-- Time Duration & Fee Stack -->
          <div class="flex items-center gap-4 text-slate-500">
            <div class="flex items-center gap-1 font-bold">
              <img src="icons/schedule_orange.svg" class="w-5 h-5" />
              <span>{{ hour(parkingList.totalTime) }}h {{ parkingList.totalTime % 60 }}m</span>
            </div>
            <div class="flex items-center gap-1 font-bold">
              <img src="icons/payments_red.svg" class="w-6 h-6" />
              <span [ngClass]="parkingList.totalPay > 0 ? 'text-rose-500' : 'text-emerald-500'">{{ parkingList.totalPay
                | number : "1.2-2" }} ฿</span>
            </div>
          </div>

          <!-- Payment Trigger Button -->
          <button [disabled]="parkingList.totalPay <= 0" (click)="onClickPay(parkingList)"
            class="px-5 py-2.5 rounded-2xl font-black text-xs transition-all flex items-center justify-center gap-1.5 shadow-md border-none outline-none"
            [ngClass]="{
              'bg-slate-100 text-slate-400 cursor-not-allowed shadow-none': parkingList.totalPay <= 0,
              'bg-amber-400 text-slate-800 hover:bg-amber-500 active:scale-[0.97]': parkingList.totalPay > 0
            }">
            <img *ngIf="parkingList.totalPay <= 0" src="icons/credit_card_slate.svg" class="w-5 h-5" />
            <img *ngIf="parkingList.totalPay > 0" src="icons/credit_card_black.svg" class="w-5 h-5" />
            {{ parkingList.totalPay <= 0 ? (currentLang==="TH" ? "ไม่มีค้างชำระ" : "No Fee" ) : (currentLang==="TH"
              ? "ชำระเงิน" : "Pay Now" ) }} </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Premium Fullscreen Loading Overlay -->
<app-pss-loading *ngIf="isLoading"></app-pss-loading>

<!-- ✅ MODAL: Choose Payment Method -->
<div class="fixed inset-0 z-100 flex items-center justify-center bg-slate-900/40 backdrop-blur-sm px-3 animate-fade-in"
  *ngIf="isOpenModalChose">
  <div class="bg-white w-full sm:max-w-sm rounded-[2.5rem] p-6 relative animate-scale-up border border-slate-100/50">

    <!-- Close Button -->
    <button (click)="closeModal()"
      class="absolute top-4 right-4 w-7 h-7 rounded-full bg-slate-50 hover:bg-slate-100 text-slate-400 hover:text-rose-500 transition-colors flex items-center justify-center outline-none border-none">✕</button>

    <div class="flex flex-col items-center text-center">
      <img src="icons/PSS/PSS Sticker-01.png" class="w-16 h-16 mb-3 drop-shadow-md object-contain" />
      <h3 class="text-sm font-black text-slate-800">
        {{ currentLang === "TH" ? "กรุณาเลือกวิธีการชำระเงิน" : "Please choose payment method" }}
      </h3>
      <p class="text-[10px] text-slate-400 font-bold mt-0.5 mb-6">
        {{ currentLang === "TH" ? "เลือกวิธีการชำระเงินเพื่อดำเนินการต่อ" : "Select a method below to complete payment"
        }}
      </p>

      <!-- Pay options button stack -->
      <div class="w-full space-y-3">
        <!-- QR Code -->
        <button (click)="navigateToQr()"
          class="w-full py-3.5 bg-amber-400 text-slate-800 rounded-2xl font-black shadow-md hover:bg-amber-500 active:scale-[0.98] transition-all flex items-center justify-center gap-1.5 border-none outline-none text-xs">
          <img src="icons/qr_code_2_black.svg" class="w-5 h-5" />
          {{ currentLang === "TH" ? "ชำระด้วย QR Code (ThaiQR)" : "Pay with ThaiQR" }}
        </button>

        <!-- Top-up account balance -->
        <button (click)="navigateToTopup()"
          class="w-full py-3.5 bg-slate-100 hover:bg-slate-200/80 text-slate-700 rounded-2xl font-black active:scale-[0.98] transition-all flex items-center justify-center gap-1.5 outline-none border-none text-xs">
          <img src="icons/account_slate_black.svg" class="w-5 h-5" />
          {{ currentLang === "TH" ? "ชำระด้วยบัญชีเติมเงิน" : "Pay with Top Up Account" }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- ✅ MODAL: Topup Confirmation Details -->
<div *ngIf="isOpenModalTopup"
  class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/40 backdrop-blur-sm animate-fade-in">
  <div
    class="bg-white w-full max-w-sm rounded-[2.5rem] overflow-hidden shadow-2xl animate-scale-up border border-slate-100/50 flex flex-col">
    <!-- Header -->
    <div class="bg-gradient-to-b from-[#2e2f38] to-[#1a1b20] p-6 text-center text-white relative">
      <button (click)="closeModal()"
        class="absolute top-4 right-4 w-7 h-7 rounded-full bg-white/10 hover:bg-white/20 text-white/80 flex items-center justify-center border-none outline-none">
        <img src="icons/close_white.svg" class="w-5 h-5" />
      </button>
      <h2 class="text-base font-black tracking-wide text-white mb-2">
        {{ currentLang === "TH" ? "ยืนยันชำระผ่านบัญชีเติมเงิน" : "Confirm Payment" }}
      </h2>
      <!-- Wallet balance badge -->
      <div
        class="inline-flex items-center gap-2 bg-white/10 border border-white/10 px-3.5 py-1 rounded-full text-white text-xs">
        <span class="opacity-80">Wallet Balance:</span>
        <span class="font-black text-amber-400">{{ topupAmount.amount | number : "1.2-2" }} ฿</span>
      </div>
    </div>

    <!-- Content details -->
    <div class="p-6 space-y-3.5 text-xs text-left">
      <div class="flex justify-between items-center border-b border-slate-100 pb-2.5">
        <span class="text-slate-400 font-bold">{{ currentLang === "TH" ? "สถานที่จอด" : "Location" }}</span>
        <span class="font-black text-slate-800">{{ selectedTransaction?.siteName }}</span>
      </div>
      <div class="flex justify-between items-center border-b border-slate-100 pb-2.5">
        <span class="text-slate-400 font-bold">{{ currentLang === "TH" ? "ทะเบียนรถ" : "License Plate" }}</span>
        <span class="font-black text-slate-800">{{ selectedTransaction?.entryLicense }}</span>
      </div>
      <div class="flex justify-between items-center border-b border-slate-100 pb-2.5">
        <span class="text-slate-400 font-bold">{{ currentLang === "TH" ? "เวลาที่จอด" : "Duration" }}</span>
        <span class="font-black text-slate-800">
          {{ hour(selectedTransaction?.totalTime ?? 0) }}h
          {{ (selectedTransaction?.totalTime ?? 0) % 60 }}m
        </span>
      </div>

      <!-- Total Fee block -->
      <div class="flex justify-between items-center bg-slate-50 p-4.5 rounded-2xl mt-2.5">
        <span class="font-black text-slate-600">{{ currentLang === "TH" ? "ยอดหักชำระรวม" : "Total Deducted" }}</span>
        <span class="font-extrabold text-lg text-rose-500">
          {{ selectedTransaction?.totalPay | number : "1.2-2" }} ฿
        </span>
      </div>
    </div>

    <!-- Action buttons footer -->
    <div class="grid grid-cols-2 gap-0 border-t border-slate-100 text-xs">
      <button (click)="closeModal()"
        class="py-4 bg-slate-50 hover:bg-slate-100 text-slate-500 font-black transition border-none outline-none">
        {{ currentLang === "TH" ? "ยกเลิก" : "Cancel" }}
      </button>
      <button (click)="paymentTopup()"
        class="py-4 bg-amber-400 hover:bg-amber-500 text-slate-800 font-black transition border-none outline-none">
        {{ currentLang === "TH" ? "ยืนยันชำระเงิน" : "Confirm" }}
      </button>
    </div>
  </div>
</div>